import React from 'react';
import { useDispatch } from 'react-redux';
import { issueCard } from 'lib/actions';

import LSDStatusCardModal from '../presentational/LSDStatusCardModal';

const LSDStatusCardModalContainer = ({ hideModal }) => {
    const dispatch = useDispatch();

    const handleClose = () => hideModal();

    const handleSubmit = () => {
        dispatch(issueCard());
        handleClose();
    };

    return (
        <div className="status-card-modal">
            <LSDStatusCardModal
                handleSubmit={handleSubmit}
                handleClose={handleClose}
            />
        </div>
    );
};

export default LSDStatusCardModalContainer;
